import { render } from "./AttachmentInlineList.vue?vue&type=template&id=044fb091"
import script from "./AttachmentInlineList.vue?vue&type=script&lang=js"
export * from "./AttachmentInlineList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/fishing-license/fishing-license-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__